import { render, staticRenderFns } from "./DeliveryButton.vue?vue&type=template&id=7d661afe&"
import script from "./DeliveryButton.vue?vue&type=script&lang=js&"
export * from "./DeliveryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports